import { Button, Heading, Menu, SegmentGroup } from '@components'
import { useAuth } from '@state'
import { Index } from 'solid-js'
import { useService } from 'solid-services'
import { Box, HStack } from 'styled-system/jsx'
import { ListTypes, useList } from '../state'

const Display = (props: { option: ListTypes }) => {
	return props.option
}

export default function ListSelector() {
	const { listType, setListType } = useService(useList)()
	const { isAdmin } = useService(useAuth)()

	const activeOptions = () => {
		const options = Object.values(ListTypes)

		if (isAdmin()) {
			// options.push(ListTypes.inactive)
		}

		return options
	}

	return (
		<>
			<SegmentGroup.Root
				display={{
					base: 'flex',
					mdDown: 'none',
				}}
				colorPalette="tscGreen"
				orientation="horizontal"
				value={listType()}
				onValueChange={({ value }) => setListType(value as ListTypes)}
			>
				<SegmentGroup.Indicator />
				<Index each={activeOptions()}>
					{(option) => (
						<SegmentGroup.Item value={option()}>
							<SegmentGroup.ItemText textTransform="capitalize">
								<Display option={option()} />
							</SegmentGroup.ItemText>
							<SegmentGroup.ItemControl />
							<SegmentGroup.ItemHiddenInput />
						</SegmentGroup.Item>
					)}
				</Index>
			</SegmentGroup.Root>
			<Box
				display={{
					base: 'none',
					mdDown: 'block',
				}}
			>
				<Menu.Root onSelect={({ value }) => setListType(value as ListTypes)}>
					<Menu.Trigger>
						<Button
							variant="outline"
							size="xs"
						>
							<Heading textTransform="capitalize">
								{listType() === ListTypes.published ? 'Published' : `My ${listType()}`}
							</Heading>
						</Button>
					</Menu.Trigger>
					{/* <Portal> */}
					<Menu.Positioner>
						<Menu.Content>
							<Menu.ItemGroup>
								<Index each={activeOptions()}>
									{(option) => (
										<Menu.Item value={option()}>
											<HStack gap={2}>
												<Heading textTransform="capitalize">
													<Display option={option()} />
												</Heading>
											</HStack>
										</Menu.Item>
									)}
								</Index>
							</Menu.ItemGroup>
						</Menu.Content>
					</Menu.Positioner>
					{/* </Portal> */}
				</Menu.Root>
			</Box>
		</>
	)
}
